<div class="list-block-item__container">
  <button
    mat-list-item
    class="list-block-item__block"
    [attr.data-testid]="'list-blocks-' + row().id + '-button'"
    [class.active]="active()"
    (click)="activate.emit(row().id)"
  >
    <div class="list-block-item__block-text">
      <fa-icon [icon]="blockTypeIconConfig[row().type].icon"></fa-icon>
      <span class="fs__sm">{{ row().id }}. {{ row().title }}</span>
    </div>
    @for (subBlock of row().subBlocks; track subBlock.id) {
      <div class="list-block-item__block-text sub-item">
        <fa-icon [icon]="blockTypeIconConfig[subBlock.type].icon"></fa-icon>
        <span class="fs__sm">{{ subBlock.id }}. {{ subBlock.title }}</span>
      </div>
    }
  </button>
</div>
